module.exports = __webpack_public_path__ + "img/LV2.5dcba246.webp";